import React from 'react';

import {
  clearAccessToken,
  clearRefreshToken,
  clearUserSession,
  getAccessToken,
  getCookie,
  getRefreshToken,
  setAccessTokenToDomain,
  setCookie,
  setRefreshTokenToDomain,
  setUserId
} from '../utils/AccountsStorageUtils';
import {
  getPaymentAccessToken,
  setPaymentsAccessTokenToDomain,
  setPaymentsRefreshTokenToDomain
} from '../utils/PaymentStorageUtils';

interface StorageUtilsProviderState {
  getAccessToken: () => string;
  getRefreshToken: () => string;
  setAccessTokenToDomain: (accessToken: string) => void;
  setRefreshTokenToDomain: (refreshToken: string) => void;
  clearAccessToken: () => void;
  clearRefreshToken: () => void;
  clearUserSession: () => void;
  setPaymentsAccessTokenToDomain: (accessToken: string) => void;
  setPaymentsRefreshTokenToDomain: (refreshToken: string) => void;
  setUserId: (userId: string) => void;
  getCookie: (userId: string) => string;
  setCookie: (userId: string, cookie: string) => void;
  getPaymentAccessToken: () => string;
}

const StorageUtilsContext = React.createContext<StorageUtilsProviderState>({
  getAccessToken,
  getRefreshToken,
  clearUserSession,
  setPaymentsAccessTokenToDomain,
  setPaymentsRefreshTokenToDomain,
  setUserId,
  setAccessTokenToDomain,
  setRefreshTokenToDomain,
  clearAccessToken,
  clearRefreshToken,
  getCookie,
  setCookie,
  getPaymentAccessToken
});

export const useStorageUtils = () => {
  const context = React.useContext(StorageUtilsContext);

  if (!context)
    throw new Error('Expected to be wrapped in a StorageUtilsProvider');

  return context;
};

export const StorageUtilsProvider = ({ children, initialValues }) => {
  return (
    <StorageUtilsContext.Provider
      value={{
        ...initialValues
      }}
    >
      {children}
    </StorageUtilsContext.Provider>
  );
};
